export const CoolblueEmployeeRole = {
    STORE_EMPLOYEE: 'CFC_STORE',
    CUSTOMER_SERVICE_EMPLOYEE: 'CFC_CUSTOMER_SERVICE',
};
//# sourceMappingURL=coolblueEmployeeRole.js.map